import type { StaticImageResponse } from "@da-web/common";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useStaticImagePreloader = (brand: string) =>
  useSuspenseQuery({
    queryKey: ["static-images"],
    queryFn: async () => {
      const response = await fetch(`static/menu-images?time=${Date.now()}`, {
        headers: {
          "x-brand-id": brand,
        },
      });

      const result: StaticImageResponse = await response.json();
      return result.staticMenuImages;
    },
  });
